module.exports = __webpack_public_path__ + "img/ip-cctvimg-3.6d79d90c.png";